import React from 'react';
import WalletDashboard from '../components/wallet/WalletDashboard';

const WalletPage = () => {
  return <WalletDashboard />;
};

export default WalletPage;